<app-card class="header">
  <div>
    <app-ribbon type="idea" />
    <h1 class="title" i18n>Soil Compaction</h1>
    <p i18n><b>Investigate how you can reduce soil compaction with intelligent route planning</b></p>
    <p i18n>
      In this project the goal is to use intelligent route planning to minimize soil compaction. You provide information
      about the operation, machinery and tire configuration, and the tool will come up with route suggestions optimized
      according to various parameters like time, fuel consumption and soil compaction. You can then simply choose the
      route that best suits your needs.
    </p>
  </div>
  <div>
    <div class="subtitle" i18n>Have a look</div>
    <p i18n>
      Take a look at the scenario that illustrates how a tool could be used to reduce soil compaction. Reflect on how it
      would fit into your daily work.
    </p>
    <p i18n>Examine the route suggestion examples and consider which one you would choose if it was your field.</p>
    <p class="info-feedback">
      <span i18n>... and let us know what you think -</span>
      <app-link i18n target="_self" [href]="goToFeedback()">send your feedback</app-link>
    </p>
  </div>
</app-card>
<app-card>
  <app-card-title i18n-title title="Imagine you could minimize soil compaction" />
  <app-steps [steps]="steps" />
</app-card>
<div class="routes">
  <app-card>
    <app-card-title i18n-title title="Route suggestion 1: no optimization" />
    <app-metrics [metrics]="metrics.time" />
    <img src="images/SC_notoptimized.png" i18n-alt alt="Not optimized" />
    <h3 i18n>Click to see route suggestion 1</h3>
    <video controls (play)="onPlay(1)">
      <source src="videos/SC_not_optimized.mp4" type="video/mp4" />
      <span i18n>Your browser does not support the video tag.</span>
    </video>
  </app-card>
  <app-card>
    <app-card-title i18n-title title="Route suggestion 2: Reducing soil compaction" />
    <app-metrics [metrics]="metrics.compaction" />
    <img src="images/SC_optimized.png" i18n-alt alt="Optimized" />
    <h3 i18n>Click to see route suggestion 2</h3>
    <video controls (play)="onPlay(2)">
      <source src="videos/SC_optimized.mp4" type="video/mp4" />
      <span i18n>Your browser does not support the video tag.</span>
    </video>
  </app-card>
</div>
<app-card id="feedback">
  <app-feedback-card feature="soil-compaction" />
</app-card>
